<template>
  <select :disabled="disabled" :value="value" v-on:change="changeHandler">
    <option v-if="emptyOption" value="">{{ emptyOption }}</option>
    <option 
      v-for="option in options"
      :key="option.id"
      :value="option.id"
      :disabled="option.id === ''"
      :selected="option.id === value"
    >{{ option.name }}
    </option>
  </select>
</template>

<script>
  import Vue from 'vue';

  export default Vue.component('SelectTag', {
    props: {
      name: String,
      value: String,
      options: {
        type: Array,
        default: () => [],
      },
      placeholder: String,
      loading: Boolean,
      change: Function,
    },
    methods: {
      changeHandler: function(event) {
        let index = event.target.options.selectedIndex;
        if (this.emptyOption) index -= 1;
        const value = (index > -1) ? this.options[index].id : null;
        this.change({ [this.name]: value });
      }
    },
    computed: {
      // add "disabled" attribute if no options or if the only option is "loading"
      disabled: function() {
        return (this.options.length === 0 || (this.options.length === 1 && this.options[0].id === 'loading')) ? true : false;
      },
      emptyOption: function() {
        return (this.loading) ? 'Loading...' : this.placeholder;
      }
    },
  });
</script>